<template>
  <ib-card class="pa-4" :animation="false">
    <div class="d-flex summary-card">
      <img class="summary-image" :src="image" :class="{'disabled': disabled}" alt="">
      <div>
        <p class="ma-0 price">
          {{ price }}
        </p>
        <p class="ma-0 title">
          {{ title }}
        </p>
      </div>
    </div>
  </ib-card>
</template>

<script>
export default {
  name: 'SummaryCard',
  props: {
    image: {
      type: String,
      required: true
    },
    price: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.price {
  line-height: 32px;
  font-size: 28px;
  font-family: $outfit-medium;
}

.title {
  font-size: 1.1rem !important;
  font-family: 'outfit-light', sans-serif !Important;
  color: $color-font-light;
}

.summary-image {
  margin-right: 25px;
  padding-left: 16px;
  width: 70px;

  &.disabled {
    filter: grayscale(100%);
    opacity: .5;
  }
}
</style>
